/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AccountPaymentSubmittedTable, AccountAuthorisationPanel } from 'web-ui-components/lib/finance/accounts';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { Divider } from 'web-ui-components/lib/atoms/layout';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import withContent from '../../../containers/withContent';
import chapsSubmittedContent, { contentPropTypes } from './chapsSubmitted.content';
import { isBatch, getBatchName, isBatchConfirmationObligated } from '../../../states/batch/selectors';
import {
	getChapsSubmittedPaymentsList,
	getChapsPaymentsAwaitingAuthorisation,
	getChapsFailedPaymentsList,
	getChapsPendingPaymentsList,
	getChapsBatchSubmittedPaymentsList,
	isHardTokenAuthorisation,
} from '../../../states/chaps/selectors';

import ChapsSubmittedAuthorisePanel from './ChapsSubmittedAuthorisePanel';

const mapState = (state) => ({
	chapsSubmittedPayments: getChapsSubmittedPaymentsList(state),
	chapsBatchSubmittedPayments: getChapsBatchSubmittedPaymentsList(state),
	chapsPaymentsAwaitingAuthorisation: getChapsPaymentsAwaitingAuthorisation(state),
	batchName: getBatchName(state),
	isBatch: isBatch(state),
	chapsFailedPayments: getChapsFailedPaymentsList(state),
	chapsPendingPayments: getChapsPendingPaymentsList(state),
	batchRequiresAuthorisation: isBatchConfirmationObligated(state),
	isHardTokenAuthorisation: isHardTokenAuthorisation(state),
});

const ChapsSubmittedPayments = ({
	chapsSubmittedPayments = [],
	chapsPaymentsAwaitingAuthorisation = [],
	batchName,
	isBatch,
	chapsFailedPayments = [],
	chapsPendingPayments = [],
	content,
	batchRequiresAuthorisation,
	chapsBatchSubmittedPayments = [],
	isHardTokenAuthorisation,
	handleRoute,
}) => {
	const { fromLabel, toLabel, amtLabel, refLabel, dateLabel, typeLabel, feesLabel } = content;
	const headerData = [
		{
			type: 'account',
			label: fromLabel,
		},
		{
			type: 'account',
			label: toLabel,
		},
		{
			type: 'currency',
			label: amtLabel,
		},
		{
			type: 'iban',
			label: refLabel,
		},
		{
			type: 'date',
			label: dateLabel,
		},
		{
			type: 'type',
			label: typeLabel,
		},
		{
			type: 'currency',
			label: feesLabel,
		},
		{
			type: 'authorisation',
			label: '',
		},
	];

	const chapsPaymentsAwaitingAuthWithMessage = chapsPaymentsAwaitingAuthorisation.map((item) => {
		if (item.subLabel === 'HardTokenContent') return { ...item, subLabel: content.hardToken };
		if (item.subLabel === 'SoftTokenContent') return { ...item, subLabel: content.softToken };
		return item;
	});

	return (
		<div>
			{chapsFailedPayments.length > 0 && !isBatch && (
				<div>
					<SectionHeading>{content.FailedLabel}</SectionHeading>
					<Divider />
					<AccountPaymentSubmittedTable headerData={headerData} tableData={chapsFailedPayments} />
				</div>
			)}
			{chapsPendingPayments.length > 0 && !isBatch && (
				<div>
					<SectionHeading>{content.PendingLabel}</SectionHeading>
					<Divider />
					<AccountPaymentSubmittedTable headerData={headerData} tableData={chapsPendingPayments} />
				</div>
			)}
			{chapsPaymentsAwaitingAuthorisation.length > 0 && !isBatch && (
				<div>
					<SectionHeading>{content.ItemsAwaitingAuthorisationLabel}</SectionHeading>
					<Divider />
					{isHardTokenAuthorisation && (
						<AccountAuthorisationPanel>
							<center>
								<p>{content.authorisationNavigation}</p>
							</center>
							<div style={{ textAlign: 'center' }}>
								<NavigationButton.Primary
									labelText={content.authoriseButtonText}
									onClick={() => handleRoute('WEB-MANAGE-PAYMENT-STATUS')}
								/>
							</div>
						</AccountAuthorisationPanel>
					)}
					<AccountPaymentSubmittedTable
						headerData={headerData}
						viewAuthorisersOnClick={() => {}}
						tableData={chapsPaymentsAwaitingAuthWithMessage}
					/>
				</div>
			)}
			{chapsSubmittedPayments.length > 0 && !isBatch && (
				<div>
					<SectionHeading>{content.SubmittedLabel}</SectionHeading>
					<Divider />
					<AccountPaymentSubmittedTable
						headerData={headerData}
						viewAuthorisersOnClick={() => {}}
						tableData={chapsSubmittedPayments}
					/>
				</div>
			)}
			{isBatch && chapsBatchSubmittedPayments.length > 0 && (
				<div>
					<SectionHeading>{batchName}</SectionHeading>
					<Divider />
					{batchRequiresAuthorisation && <ChapsSubmittedAuthorisePanel handleRoute={handleRoute} />}
					<AccountPaymentSubmittedTable
						headerData={headerData}
						viewAuthorisersOnClick={() => {}}
						tableData={chapsBatchSubmittedPayments}
					/>
				</div>
			)}
		</div>
	);
};

ChapsSubmittedPayments.propTypes = {
	chapsSubmittedPayments: PropTypes.arrayOf(PropTypes.shape({})),
	chapsPaymentsAwaitingAuthorisation: PropTypes.arrayOf(PropTypes.shape({})),
	chapsFailedPayments: PropTypes.arrayOf(PropTypes.shape({})),
	chapsPendingPayments: PropTypes.arrayOf(PropTypes.shape({})),
	content: PropTypes.shape(contentPropTypes),
	isBatch: PropTypes.bool,
	batchName: PropTypes.string,
	batchRequiresAuthorisation: PropTypes.bool,
	chapsBatchSubmittedPayments: PropTypes.arrayOf(PropTypes.shape({})),
	isHardTokenAuthorisation: PropTypes.bool,
	handleRoute: PropTypes.func,
};

const contentWrapper = withContent({ content: chapsSubmittedContent });
export default connect(mapState)(contentWrapper(ChapsSubmittedPayments));
export const ConnectWrapper = connect(mapState)(ChapsSubmittedPayments);
